import Screens from 'shared/screens';

const modalBlackList = [Screens.DailySpin];
export const checkModalBlackList = modal => !!modal && modalBlackList.includes(modal);

